import { Platform } from 'react-native'

import {
  normalizeFontFamily,
  translateFontWeight,
  handleFontSize,
} from './type'
import { normalizeColor } from './colors'

export const getShadowStyles = shadow => {
  if (!shadow || !shadow.enabled) {
    return null
  }

  let styles = {
    shadowColor: shadow.color,
    shadowOffset: { width: shadow.x || 0, height: shadow.y || 0 },
    shadowOpacity: 1,
    shadowRadius: shadow.size || 0,
  }

  // TODO: Fix this by adding proper android shadows
  // if (Platform.OS === 'android') {
  //   styles.elevation = 1
  // }

  return styles
}

export const normalizeStyles = (prop = {}, attributes = {}, branding = {}) => {
  const { styles: defaultStyles } = prop

  let result = { ...defaultStyles }

  for (const key of Object.keys(defaultStyles)) {
    const target = (attributes.styles && attributes.styles[prop.name]) || {}
    const { fontFamily, fontWeight } = target || defaultStyles

    let currentValue = target[key] || attributes[key] || defaultStyles[key]

    switch (key) {
      case 'fontFamily': {
        result[key] = normalizeFontFamily(currentValue, branding, {
          fontWeight: translateFontWeight(fontWeight, currentValue, branding),
        })
        break
      }
      case 'fontWeight': {
        if (Platform && Platform.OS === 'android') {
          result[key] = null
        } else {
          result[key] = translateFontWeight(currentValue, fontFamily, branding)
        }

        break
      }
      case 'fontSize': {
        result[key] = handleFontSize(currentValue)
        break
      }
      case 'color': {
        result[key] = normalizeColor(currentValue, branding, prop)
        break
      }
      case 'textAlignment': {
        result.textAlign = currentValue
        delete result.textAlignment
        break
      }
      default: {
        result[key] = currentValue
        break
      }
    }
  }

  return result
}
